import React, { useEffect, useState } from "react";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Footer } from "../components/site/Footer";
import { Contact } from "../components/site/Contact";
import { FloatingCTA } from "../components/site/FloatingCTA";
import { CookieBanner } from "../components/site/CookieBanner";
import { Marquee, Solutions, AppShowcase, LandingSection, Services, Portfolio, WhyUs, Process, HelpSection, Pricing, Testimonials, FAQ, FinalCta } from "../components/site/Sections";
import { useLenis } from "../hooks/useLenis";
import { api } from "../lib/api";

const DEFAULT_SETTINGS = { app_price_oneoff: "499", app_price_monthly: "29", landing_price: "299" };

export default function Home() {
  useLenis();
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [portfolio, setPortfolio] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [faq, setFaq] = useState([]);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/portfolio").then((r) => setPortfolio(r.data)).catch(() => {});
    api.get("/testimonials").then((r) => setTestimonials(r.data)).catch(() => {});
    api.get("/faq").then((r) => setFaq(r.data)).catch(() => {});
  }, []);

  return (
    <div className="App relative">
      <div className="noise-overlay" />
      <Header />
      <main>
        <Hero />
        <Solutions />
        <Marquee />
        <AppShowcase settings={settings} />
        <LandingSection settings={settings} />
        <Services />
        <Portfolio items={portfolio} />
        <WhyUs />
        <Process />
        <HelpSection />
        <Pricing settings={settings} />
        <Testimonials items={testimonials} />
        <FAQ items={faq} />
        <FinalCta />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
      <CookieBanner />
    </div>
  );
}
